module.exports = __webpack_public_path__ + "img/map-message-4.1e0df12d.png";